import ClipLoader from "react-spinners/ClipLoader";
import "./LoadingCompHover.scss"

export default function LoadingCompHover({white = false}) {
    return (
        <div className={"loading-comp-hover"}>
            <ClipLoader color={white ? '#ffffff' : '#6C5DD3'} loading={true} size={25} />
        </div>
    );
}